import { createStore } from 'vuex'

const store = createStore({
    state() {
        return {
            count: 25,
            type: 0,//
            divid:'',
            divData: {},
            userDetail: {},
            errors: [],
            order:0,
            tableData: [],//表格数据
            hop:{},
            value:'',
            tableConfig: {},
            profileConfig: '',
            unitList: "",
            openYear:'',
            openType:''
        }
    },
    mutations: {
        changeopenYear(state, key) {
            state.openYear = key
        },
        changeopenType(state, key) {
            state.openType = key
        },
        changeValue(state, key) {
            state.value = key
        },
        increment(state) {
            state.count++
        },
        changeDivid(state, key) {
            state.divid = key
        },
        changeDivData(state, key) {
            state.divData = key
        },
        changeUserDetail(state, key) {
            state.userDetail = key
        },
        changeDivType(state, key) {
            state.type = key
        },
        changeAddError(state, key) {
            state.errors.push(key)
        },
        changeRemoveError(state, key) {
            let idx = state.errors.findIndex(e => e.key == key)
            if (idx > -1)
                state.errors.splice(idx, 1)
        },
        addOrder(state) {
            if (state.order < 0) {
                state.order = 0
            }
            state.order++
        },
        reduceOrder(state) {
            if (state.order > 0) {
                state.order--
            }
        },
        resetMessage(state) {
            state.errors = []
            state.order = 0
        },
        resetOrder(state) {
            state.order = 0
        },
        resetErrors(state) {
            state.errors = []
        },
        storageHop(state, hop) {
            state.hop = hop
        },
        changeTableData(state, tableData) {
            state.tableData = tableData
        },
        storageIndex(state, dataIndex) {
            state.dataIndex = dataIndex
        },
        resetTableConfig(state) {
            state.tableData = []
            state.hop = {}
        },
        changeTableConfig(state, key) {
            state.tableConfig = key
        },
        updateProfileConfig(state, key) {
            state.profileConfig = key
        },
        changeUnitList(state, key) {
            state.unitList = key
        }
    

    }
})
export default {
    store
}